export const environment = {
    production: false,
    instanceTag: "Test",
    firebaseConfig: {
        apiKey: "AIzaSyAtExp9Sql3qqnIstTwBvq67dS_8VAfCzU",
        authDomain: "prologix-test.firebaseapp.com",
        databaseURL: "https://prologix-test-default-rtdb.asia-southeast1.firebasedatabase.app",
        projectId: "prologix-test",
        storageBucket: "prologix-test.appspot.com",
        messagingSenderId: "862331447268",
        appId: "1:862331447268:web:36c8d51a66d2604281c9f1",
        measurementId: "G-E42SB2VW33"
    },
    firebaseVapidKey: "BGSm2CiPB8-UDfNEAxW-FPxeeYhUVATupZRzipH-ddhqa31Bi9DpEdd1LVGZjpFH11P1BLwWPRAPT45ubWxBvVg",
    bigQueryDatasetPath: "prologix-test",
    googleApiKey: "AIzaSyDGZ8TrVDHqCjEOtfjUws-iaLJ1WbndUDM",
    traccarFleetApiKey: "RzBFAiAjmRX8y8WjQHAb5l4NsSGtgKLb6I3Jj2smAUbYY3IENwIhANrW8VJEt0sK08EiVpRpna71cTqgwDjN50mrEhb92PiIeyJ1IjoxMCwiZSI6IjIwMjYtMDEtMjVUMjE6MDA6MDAuMDAwKzAwOjAwIn0",

    // Test portal is wired to the shared non-production backend services.
    restApiTargetLabel: "remote-test-cloud-run",
    reactiveApiUrl: "https://transaction-api-7tg7bixpgq-el.a.run.app/api/",
    // The active non-production AI Cloud Run service is deployed in asia-south1.
    // The previous asia-southeast1 URL is no longer routed and causes browser
    // uploads to fail before they reach the document-extraction endpoints.
    aiServiceApiUrl: "https://embabel-agentic-service-862331447268.asia-south1.run.app/api/",
    reportsApiUrl: "https://reports-api-862331447268.asia-south1.run.app/api/",
    paymentApiUrl: "https://payment-api-862331447268.asia-south1.run.app/api/",
    restApiUrl: "https://rest-api-862331447268.asia-south1.run.app/api/",
    traccarFleetApiUrl: "http://iot-tracking.cargomate.co/api/",
    fuelProviderBaseUrls: {
        PETROAPP: "https://app-public.staging.petroapp.app/webservice/",
        ALDREES_WAIE: "https://devint.aldrees.com/api/"
    },
    whatsAppOtpEnabled: true
};
